/**
 * Turkish to English character mapping for URL-safe conversion
 */
const turkishToEnglishMap = {
  'ı': 'i', 'İ': 'I',
  'ğ': 'g', 'Ğ': 'G', 
  'ü': 'u', 'Ü': 'U',
  'ş': 's', 'Ş': 'S',
  'ö': 'o', 'Ö': 'O',
  'ç': 'c', 'Ç': 'C'
};

/**
 * Convert Turkish characters to English equivalents
 * @param {string} text - Text with Turkish characters
 * @returns {string} Text with Turkish characters replaced
 */
export const convertTurkishChars = (text) => {
  if (!text) return '';
  
  return text.split('').map(char => turkishToEnglishMap[char] || char).join('');
};

/**
 * Generate a URL-safe slug from a title
 * @param {string} title - Original title
 * @returns {string} URL-safe slug
 */
export const generateSlug = (title) => {
  if (!title || typeof title !== 'string') {
    return '';
  }

  return convertTurkishChars(title)
    .toLowerCase()                    // Convert to lowercase
    .trim()                          // Remove leading/trailing spaces
    .replace(/[^\w\s-]/g, '')        // Remove special characters except spaces and hyphens
    .replace(/[\s_-]+/g, '-')        // Replace spaces, underscores, multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, '');        // Remove leading/trailing hyphens
};

/**
 * Check if a string is a valid MongoDB ObjectId
 * @param {string} str - String to check
 * @returns {boolean} True if valid ObjectId format
 */
export const isValidObjectId = (str) => {
  if (!str || typeof str !== 'string') return false;
  return /^[0-9a-fA-F]{24}$/.test(str);
};

/**
 * Determine whether to use slug or ObjectId for timeline URL
 * @param {object} timeline - Timeline object
 * @returns {string} Preferred identifier for URL
 */
export const getTimelineUrlId = (timeline) => {
  if (!timeline) return '';
  
  // Prefer slug if available and valid
  if (timeline.slug && timeline.slug.length > 0) {
    return timeline.slug;
  }
  
  // Fallback to ObjectId
  return timeline._id || timeline.id || '';
}; 